import 'video-react/dist/video-react.css'; // import css

import { Button, Icon, Image, Typography } from '@smartgift/frontend-toolkit';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import * as S from './style';

const Player = React.lazy(() => import('video-react').then(module => ({ default: module.Player })));

export function Advantages() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const theme = useTheme();

  return (
    <S.Advantages>
      <Typography style={{ textAlign: 'center' }} variant="subtitle2Bold">
        {t('upYourGiftingGame')}
      </Typography>
      <S.AdvantagesVideo>
        {isOpen ? (
          <Player autoPlay width="444px" height="250px" preload="auto">
            <source src={t('signUpPromoVideo')} />
          </Player>
        ) : (
          <React.Fragment>
            <Image width={'100%'} height={250} src={theme.images.signUpVideoBackground} />
            <Button onClick={() => setIsOpen(true)} startIcon={<Icon name="play" />}>
              {t('watchVideo')}
            </Button>
          </React.Fragment>
        )}
      </S.AdvantagesVideo>
      <S.AdvantagesList>
        <S.AdvantagesItem>
          <S.AdvantagesItemIcon>
            <Icon name="scale" size="lg" />
          </S.AdvantagesItemIcon>
          <S.AdvantagesItemInfo>
            <Typography variant="subtitle4Bold">{t('flexibleScale')}</Typography>
            <Typography variant="body2">{t('sendGiftsTo')}</Typography>
          </S.AdvantagesItemInfo>
        </S.AdvantagesItem>

        <S.AdvantagesItem>
          <S.AdvantagesItemIcon>
            <Icon name="diamond" size="lg" />
          </S.AdvantagesItemIcon>
          <S.AdvantagesItemInfo>
            <Typography variant="subtitle4Bold">{t('familyOfBrands')}</Typography>
            <Typography variant="body2">{t('inHouseBrands')}</Typography>
          </S.AdvantagesItemInfo>
        </S.AdvantagesItem>

        <S.AdvantagesItem>
          <S.AdvantagesItemIcon>
            <Icon name="payment-method" size="lg" />
          </S.AdvantagesItemIcon>
          <S.AdvantagesItemInfo>
            <Typography variant="subtitle4Bold">{t('convenientPayments')}</Typography>
            <Typography variant="body2">{t('payWithMethod')}</Typography>
          </S.AdvantagesItemInfo>
        </S.AdvantagesItem>
      </S.AdvantagesList>
    </S.Advantages>
  );
}
